import {getTranslation} from "./get-translation";

export function createToast(key, timeout, args){
	const translation = getTranslation(key, args);
	return {
		message: translation,
		timeout
	}
}